/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- SECTION LOADER : STYLES --------------- ++++++++++ */
export default theme => ({
    loading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
});
